import React from 'react';
import { useParams } from 'react-router-dom';
import PhoneCapturePageContent from './content';
import { PageContextProvider } from './context';

const PhoneCapturePage = () => {
  const { virtualPhoneNumber } = useParams();

  return (
    <PageContextProvider vpn={virtualPhoneNumber}>
      <PhoneCapturePageContent />
    </PageContextProvider>
  );
};

export default PhoneCapturePage;
